import { Routes } from '@angular/router';
import { RoutePathsEnum } from '@app/app.utils';
import { AuthGuard } from '@shared/guards/auth.guard';
import { maintenanceModeGuard, maintenancePageGuard } from '@shared/guards/maintenance.guard';

export const routes: Routes = [
  {
    path: RoutePathsEnum.Maintenance,
    canActivate: [maintenancePageGuard],
    loadComponent: () => import('@shared/components/maintenance/maintenance.component').then((c) => c.MaintenanceComponent),
    data: { title: 'Maintenance' },
  },
  {
    path: 'platform',
    canMatch: [maintenanceModeGuard],
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./platform/platform.routes').then((r) => r.platformRoutes),
    data: { preload: true },
  },
  {
    path: ':type',
    outlet: 'modal',
    canMatch: [maintenanceModeGuard],
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./platform/platform.routes').then((r) => r.platformRoutes),
  },
  {
    path: 'landing',
    redirectTo: 'landing/login',
  },
  {
    path: 'landing',
    canMatch: [maintenanceModeGuard],
    loadChildren: () => import('./landing/landing.routes').then((r) => r.landingRoutes),
  },
  {
    path: '',
    redirectTo: 'platform',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'platform',
  },
];
